export default __webpack_public_path__ + "static/media/comic1_Panel2.2424629b.png";